/*
 * Baoba — Produits associés : carrousel horizontal (flèches + points)
 */
(function () {
  function initRelated(root) {
    if (root.dataset.baobaRelatedInit) return;
    var track = root.querySelector('[data-baoba-related-track]');
    if (!track) return;
    root.dataset.baobaRelatedInit = 'true';

    var dotsWrap = root.querySelector('[data-baoba-related-dots]');
    var prevBtn = root.querySelector('[data-baoba-related-prev]');
    var nextBtn = root.querySelector('[data-baoba-related-next]');
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-baoba-related-slide]'));
    if (!slides.length) return;

    var dots = [];
    var ticking = false;

    function slideStep() {
      if (slides.length < 2) return track.clientWidth;
      return slides[1].offsetLeft - slides[0].offsetLeft;
    }

    function perView() {
      var step = slideStep();
      if (!step) return 1;
      return Math.max(1, Math.round(track.clientWidth / step));
    }

    function pageCount() {
      return Math.max(1, Math.ceil(slides.length / perView()));
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      dots = [];
      var count = pageCount();
      if (count <= 1) return;
      for (var i = 0; i < count; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'baoba-related__dot';
        dot.setAttribute('aria-label', 'Aller à la page ' + (i + 1));
        dot.addEventListener('click', (function (idx) {
          return function () {
            goToPage(idx);
          };
        })(i));
        dotsWrap.appendChild(dot);
        dots.push(dot);
      }
      updateState();
    }

    function goToPage(idx) {
      var pv = perView();
      var target = slides[idx * pv];
      if (!target) return;
      track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }

    function updateState() {
      var pv = perView();
      var step = slideStep();
      var page = step ? Math.round(track.scrollLeft / (step * pv)) : 0;
      page = Math.max(0, Math.min(dots.length - 1, page));
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === page);
      });
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 4;
      if (nextBtn) nextBtn.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        updateState();
        ticking = false;
      });
    }

    track.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', function () {
      buildDots();
      requestUpdate();
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -slideStep() * perView(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: slideStep() * perView(), behavior: 'smooth' });
      });
    }

    buildDots();
    requestUpdate();
  }

  function initAll() {
    document.querySelectorAll('[data-baoba-related-track]').forEach(function (track) {
      var root = track.closest('product-recommendations, .baoba-related-products');
      if (root) initRelated(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);

  document.querySelectorAll('product-recommendations').forEach(function (el) {
    new MutationObserver(initAll).observe(el, { childList: true, subtree: true });
  });
})();
